<div class="w-full p-10 top-0 cssDoc bg-gray-800 ">
  
  <h1 class="text-white text-2xl">CSS DOCUMENTATION</h1>

  <h1 class="text-white text-xl">CARDS</h1>
  <div class="card">
    <p>Default card </p>
    <p>css class: card</p>    
  </div>

  <div class="card-clickable up-on-hover">
    <p>clickable card </p>
    <p>css class: card-clickable up-on-hover</p>
  </div>


  <div class="card card-override">
    <p>gray card </p>
    <p>css class: card card-override</p>
  </div>

  <div class="card-nobg text-white">
    <p>transparent card </p>
    <p>css class: card-nobg</p>
  </div>

  <div class="card-primary">
    <p>card primary</p>
    <p>css class: card-primary</p>    
  </div>

  

  <h1 class="text-white text-xl">BUTTONS</h1>

  <div class="flex flex-wrap">
    <div class="flex flex-col p-2 grow">
      <button ejs-button class="e-primary">primary button</button>
      <p class="text-white">css class: e-primary</p>
    </div>
    <div class="flex flex-col p-2 grow">
      <button ejs-button class="e-primary e-unlock">unlock button</button>
      <p class="text-white">css class: e-primary e-unlock</p>
    </div>
    <div class="flex flex-col p-2 grow">
      <button ejs-button class="e-primary e-success">success button</button>
      <p class="text-white">css class: e-primary e-success</p>
    </div>
    <div class="flex flex-col p-2 grow">
      <button ejs-button class="e-primary e-danger">danger button</button>
      <p class="text-white">css class: e-primary e-danger</p>
    </div>
    <div class="flex flex-col p-2 grow">
      <button ejs-button class=" e-primary dl-button">*download* button</button>
      <p class="text-white">css class: dl-button</p>
    </div>
    <div class="flex flex-col p-2 grow">
      <button ejs-button class=" e-primary e-action-button">*action* button</button>
      <p class="text-white">css class: e-action-button</p>
    </div>
  </div>
 
  <div class="flex flex-wrap">
    <div class=" flex flex-col p-2 grow">
      <button ejs-button class="e-primary edit-button h-8">grid edit button</button>
      <p class="text-white">css class: edit-buttons</p>
    </div>
    <div class="flex flex-col p-2 grow">
      <button ejs-button class="e-primary delete-button h-8">delete button</button>
      <p class="text-white">css class: delete-buttons</p>
    </div>
    <div class="flex flex-col p-2 grow">
      <button ejs-button class="e-primary e-flat-add">add button</button>
      <p class="text-white">css class: e-flat-add</p>
    </div>
    <div class="flex flex-col p-2 grow">
      <button ejs-button class="form-action-button">form action button</button>
      <p class="text-white">css class: form-action-button</p>
    </div>
    <div class="flex flex-col p-2 grow">
      <button ejs-button class="form-secondary-action-button">form secondary action button</button>
      <p class="text-white">css class: form-secondary-action-button</p>
    </div>
  </div>

  <h2 class="text-white">Colors</h2>
  <div class="flex flex-wrap my-2">

    <div class="flex flex-col p-2 grow">
      <div class="w-16 h-16 rounded-2xl bg-primary">

      </div>
      <p class="text-white">css class: bg-primary</p>
    </div>

    <div class="flex flex-col p-2 grow">
      <div class="w-16 h-16 rounded-2xl bg-secondary">

      </div>
      <p class="text-white">css class: bg-secondary</p>
    </div>

    <div class="flex flex-col p-2 grow">
      <div class="w-16 h-16 rounded-2xl bg-success">

      </div>
      <p class="text-white">css class: bg-success</p>
    </div>

    <div class="flex flex-col p-2 grow">
      <div class="w-16 h-16 rounded-2xl bg-danger">

      </div>
      <p class="text-white">css class: bg-danger</p>
    </div>

  </div>

  <h3 class="text-white">Cool div blocks</h3>

  <div class="grid grid-cols-2 gap-2">    
      <div class="p-4 card-primary">
        <div class="w-full flex justify-between">
            <div class="flex flex-col">
                <span>PLACEHOLDER</span>
                <span class="font-bold text-xxl mt-1">0</span>
            </div>
            <div class="bg-primary p-4 rounded-2xl">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m2.25 0H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z" />
                </svg>                
            </div>
        </div>
      </div>
  
      <div class="p-4 card-primary">
        <div class="w-full flex justify-between">
            <div class="flex flex-col">
                <span>PLACEHOLDER</span>
                <span class="font-bold text-xxl mt-1">0</span>
            </div>
            <div class="bg-secondary p-4 rounded-2xl">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m2.25 0H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z" />
                </svg>                
            </div>
        </div>
      </div>    
  </div>
  <div class="p-4 card-primary my-4">                    
    &lt;div class="p-4 card-primary"><br/>
    &lt;div class="w-full flex justify-between"><br/>
    &lt;div class="flex flex-col"><br/>
    &lt;span>PLACEHOLDER&lt;/span><br/>
    &lt;span class="font-bold text-xxl mt-1">0&lt;/span><br/>
    &lt;/div><br/>
    &lt;div class="bg-secondary p-4 rounded-2xl"><br/>
    &lt;svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6"><br/>
    &lt;path stroke-linecap="round" stroke-linejoin="round" d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m2.25 0H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z" /><br/>
    &lt;/svg><br/>
    &lt;/div><br/>
    &lt;/div><br/>
    &lt;/div><br/>         
  </div>

  <h3 class="text-white">Cool div blocks</h3>

  <div class="grid grid-cols-2 gap-2">    
      <div class="p-4 card-primary">
        <div class="w-full flex justify-between">
            <div class="flex flex-col">
                <span>PLACEHOLDER</span>
                <span class="font-bold text-xxl mt-1">0</span>
            </div>
            <div class="bg-primary p-4 rounded-2xl">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m2.25 0H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z" />
                </svg>                
            </div>
        </div>
      </div>
  
      <div class="p-4 card-primary">
        <div class="w-full flex justify-between">
            <div class="flex flex-col">
                <span>PLACEHOLDER</span>
                <span class="font-bold text-xxl mt-1">0</span>
            </div>
            <div class="bg-secondary p-4 rounded-2xl">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m2.25 0H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z" />
                </svg>                
            </div>
        </div>
      </div>    
  </div>
  <div class="p-4 card-primary my-4">                    
    &lt;div class="p-4 card-primary"><br/>
    &lt;div class="w-full flex justify-between"><br/>
    &lt;div class="flex flex-col"><br/>
    &lt;span>PLACEHOLDER&lt;/span><br/>
    &lt;span class="font-bold text-xxl mt-1">0&lt;/span><br/>
    &lt;/div><br/>
    &lt;div class="bg-secondary p-4 rounded-2xl"><br/>
    &lt;svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6"><br/>
    &lt;path stroke-linecap="round" stroke-linejoin="round" d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m2.25 0H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z" /><br/>
    &lt;/svg><br/>
    &lt;/div><br/>
    &lt;/div><br/>
    &lt;/div><br/>         
  </div>


</div>